// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"2bd00952","391":"1819336f"}[chunkId] + ".chunk.js";
};